module.exports = __webpack_public_path__ + "img/060d834.jpg";